 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/Cover'
 import XHTMLHALFTITLE from '@/components/xhtml/Halftitle'
 import XHTMLFRONT01 from '@/components/xhtml/Front01'
 import XHTMLTITLE from '@/components/xhtml/Title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLDEDICATION from '@/components/xhtml/Dedication'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTMLLIST_OF_MAPS from '@/components/xhtml/List_of_Maps'
 import XHTMLACKNOWLEDGEMENTS from '@/components/xhtml/Acknowledgements'
 import XHTMLINTRODUCTION from '@/components/xhtml/Introduction'
 import XHTMLPROLOGUE from '@/components/xhtml/Prologue'
 import XHTMLCHAPTER01 from '@/components/xhtml/Chapter01'
 import XHTMLCHAPTER02 from '@/components/xhtml/Chapter02'
 import XHTMLCHAPTER03 from '@/components/xhtml/Chapter03'
 import XHTMLCHAPTER04 from '@/components/xhtml/Chapter04'
 import XHTMLCHAPTER05 from '@/components/xhtml/Chapter05'
 import XHTMLCHAPTER06 from '@/components/xhtml/Chapter06'
 import XHTMLCHAPTER07 from '@/components/xhtml/Chapter07'
 import XHTMLCHAPTER08 from '@/components/xhtml/Chapter08'
 import XHTMLCHAPTER09 from '@/components/xhtml/Chapter09'
 import XHTMLCHAPTER10 from '@/components/xhtml/Chapter10'
 import XHTMLCHAPTER11 from '@/components/xhtml/Chapter11'
 import XHTMLCHAPTER12 from '@/components/xhtml/Chapter12'
 import XHTMLCONCLUSIONS from '@/components/xhtml/Conclusions'
 import XHTMLTOURING from '@/components/xhtml/Touring'
 import XHTMLAPPENDIXA from '@/components/xhtml/AppendixA'
 import XHTMLAPPENDIXB from '@/components/xhtml/AppendixB'
 import XHTMLAPPENDIXC from '@/components/xhtml/AppendixC'
 import XHTMLAPPENDIXD from '@/components/xhtml/AppendixD'
 import XHTMLORDER from '@/components/xhtml/Order'
 import XHTMLSUGGESTED_READING from '@/components/xhtml/Suggested_Reading'
 import XHTMLABOUT_THE_AUTHOR from '@/components/xhtml/About_the_Author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/List_of_Maps",
 			"name" : "xhtml/List_of_Maps",
 			"component" : XHTMLLIST_OF_MAPS
 		},
 		{
 			"path" : "/xhtml/Acknowledgements",
 			"name" : "xhtml/Acknowledgements",
 			"component" : XHTMLACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/xhtml/Introduction",
 			"name" : "xhtml/Introduction",
 			"component" : XHTMLINTRODUCTION
 		},
 		{
 			"path" : "/xhtml/Prologue",
 			"name" : "xhtml/Prologue",
 			"component" : XHTMLPROLOGUE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js